// DO NOT IMPORT WITH
// import * as icons from '@mui/icons-material';
// As that packages ALL icons which is too much.

import AddShoppingCart from '@mui/icons-material/AddShoppingCart';
import Attractions from '@mui/icons-material/Attractions';
import Audiotrack from '@mui/icons-material/Audiotrack';
import AutoAwesome from '@mui/icons-material/AutoAwesome';
import BabyChangingStation from '@mui/icons-material/BabyChangingStation';
import BeachAccess from '@mui/icons-material/BeachAccess';
import Bed from '@mui/icons-material/Bed';
import BedroomBaby from '@mui/icons-material/BedroomBaby';
import BikeScooter from '@mui/icons-material/BikeScooter';
import BusinessCenter from '@mui/icons-material/BusinessCenter';
import Cake from '@mui/icons-material/Cake';
import CalendarMonth from '@mui/icons-material/CalendarMonth';
import CardGiftcard from '@mui/icons-material/CardGiftcard';
import CardTravel from '@mui/icons-material/CardTravel';
import CarRental from '@mui/icons-material/CarRental';
import CastForEducation from '@mui/icons-material/CastForEducation';
import Celebration from '@mui/icons-material/Celebration';
import CellTower from '@mui/icons-material/CellTower';
import CellWifi from '@mui/icons-material/CellWifi';
import Chair from '@mui/icons-material/Chair';
import ChargingStation from '@mui/icons-material/ChargingStation';
import CheckCircle from '@mui/icons-material/CheckCircle';
import ChildCare from '@mui/icons-material/ChildCare';
import ChildFriendly from '@mui/icons-material/ChildFriendly';
import Coffee from '@mui/icons-material/Coffee';
import CoffeeMaker from '@mui/icons-material/CoffeeMaker';
import Commute from '@mui/icons-material/Commute';
import Computer from '@mui/icons-material/Computer';
import ConnectingAirports from '@mui/icons-material/ConnectingAirports';
import Deck from '@mui/icons-material/Deck';
import Devices from '@mui/icons-material/Devices';
import DevicesOther from '@mui/icons-material/DevicesOther';
import Dining from '@mui/icons-material/Dining';
import DirectionsBike from '@mui/icons-material/DirectionsBike';
import DirectionsBusFilled from '@mui/icons-material/DirectionsBusFilled';
import DirectionsCarFilled from '@mui/icons-material/DirectionsCarFilled';
import DirectionsRailwayFilled from '@mui/icons-material/DirectionsRailwayFilled';
import Discount from '@mui/icons-material/Discount';
import Diversity3 from '@mui/icons-material/Diversity3';
import ElectricBike from '@mui/icons-material/ElectricBike';
import ElectricCar from '@mui/icons-material/ElectricCar';
import ElectricScooter from '@mui/icons-material/ElectricScooter';
import EmojiEmotions from '@mui/icons-material/EmojiEmotions';
import EmojiFoodBeverage from '@mui/icons-material/EmojiFoodBeverage';
import Euro from '@mui/icons-material/Euro';
import Event from '@mui/icons-material/Event';
import EventAvailable from '@mui/icons-material/EventAvailable';
import EvStation from '@mui/icons-material/EvStation';
import FamilyRestroom from '@mui/icons-material/FamilyRestroom';
import Favorite from '@mui/icons-material/Favorite';
import Fingerprint from '@mui/icons-material/Fingerprint';
import FitnessCenter from '@mui/icons-material/FitnessCenter';
import Flight from '@mui/icons-material/Flight';
import Forum from '@mui/icons-material/Forum';
import Garage from '@mui/icons-material/Garage';
import Groups from '@mui/icons-material/Groups';
import Handshake from '@mui/icons-material/Handshake';
import Headphones from '@mui/icons-material/Headphones';
import Help from '@mui/icons-material/Help';
import Home from '@mui/icons-material/Home';
import Hotel from '@mui/icons-material/Hotel';
import LocalActivity from '@mui/icons-material/LocalActivity';
import LocalCafe from '@mui/icons-material/LocalCafe';
import LocalDining from '@mui/icons-material/LocalDining';
import LocalDrink from '@mui/icons-material/LocalDrink';
import LocalGasStation from '@mui/icons-material/LocalGasStation';
import LocalGroceryStore from '@mui/icons-material/LocalGroceryStore';
import LocalParking from '@mui/icons-material/LocalParking';
import LocationOn from '@mui/icons-material/LocationOn';
import LtePlusMobiledata from '@mui/icons-material/LtePlusMobiledata';
import Luggage from '@mui/icons-material/Luggage';
import MedicalServices from '@mui/icons-material/MedicalServices';
import MonitorHeart from '@mui/icons-material/MonitorHeart';
import Mouse from '@mui/icons-material/Mouse';
import NightShelter from '@mui/icons-material/NightShelter';
import NoCrash from '@mui/icons-material/NoCrash';
import OutdoorGrill from '@mui/icons-material/OutdoorGrill';
import Percent from '@mui/icons-material/Percent';
import PhoneIphone from '@mui/icons-material/PhoneIphone';
import Restaurant from '@mui/icons-material/Restaurant';
import RocketLaunch from '@mui/icons-material/RocketLaunch';
import Router from '@mui/icons-material/Router';
import SavedSearch from '@mui/icons-material/SavedSearch';
import School from '@mui/icons-material/School';
import ShoppingBasket from '@mui/icons-material/ShoppingBasket';
import Shower from '@mui/icons-material/Shower';
import Spa from '@mui/icons-material/Spa';
import Star from '@mui/icons-material/Star';
import ThumbUp from '@mui/icons-material/ThumbUp';
import TouchApp from '@mui/icons-material/TouchApp';
import TurnedIn from '@mui/icons-material/TurnedIn';
import VolunteerActivism from '@mui/icons-material/VolunteerActivism';
import Wifi from '@mui/icons-material/Wifi';
import Work from '@mui/icons-material/Work';
import WorkspacePremium from '@mui/icons-material/WorkspacePremium';
import Yard from '@mui/icons-material/Yard';

export const CUSTOM_BENEFIT_ICONS: Record<string, typeof Diversity3> = {
  Diversity3,
  Forum,
  Groups,
  Devices,
  DevicesOther,
  Router,
  Wifi,
  PhoneIphone,
  ChargingStation,
  Mouse,
  Headphones,
  Computer,
  CellTower,
  LtePlusMobiledata,
  CellWifi,
  CastForEducation,
  School,
  CheckCircle,
  Euro,
  Fingerprint,
  LocationOn,
  TurnedIn,
  TouchApp,
  LocalActivity,
  Audiotrack,
  Restaurant,
  OutdoorGrill,
  LocalDining,
  LocalDrink,
  EmojiFoodBeverage,
  Dining,
  Coffee,
  CoffeeMaker,
  LocalCafe,
  WorkspacePremium,
  VolunteerActivism,
  Star,
  AutoAwesome,
  ThumbUp,
  RocketLaunch,
  SavedSearch,
  Handshake,
  Favorite,
  EmojiEmotions,
  Help,
  Celebration,
  Cake,
  Event,
  EventAvailable,
  Attractions,
  Spa,
  FitnessCenter,
  MonitorHeart,
  MedicalServices,
  Shower,
  Yard,
  Deck,
  Chair,
  AddShoppingCart,
  ShoppingBasket,
  CardGiftcard,
  Discount,
  Percent,
  LocalGroceryStore,
  Bed,
  BeachAccess,
  CardTravel,
  Home,
  Hotel,
  Luggage,
  NightShelter,
  Work,
  CalendarMonth,
  BusinessCenter,
  NoCrash,
  CarRental,
  DirectionsBike,
  BikeScooter,
  DirectionsBusFilled,
  DirectionsCarFilled,
  DirectionsRailwayFilled,
  ElectricScooter,
  ElectricCar,
  ElectricBike,
  EvStation,
  Flight,
  Garage,
  Commute,
  LocalGasStation,
  LocalParking,
  ConnectingAirports,
  BabyChangingStation,
  BedroomBaby,
  ChildFriendly,
  ChildCare,
  FamilyRestroom,
};
